module.exports = __webpack_public_path__ + "img/icon-map-pin.8210e77f.svg";